document.addEventListener('DOMContentLoaded', () => {
    // Burger Button
    const toggler = document.getElementById('navbar-toggler');
    if (toggler) {
        toggler.addEventListener('click', () => {
            toggler.classList.toggle("is-active");
        });
    }

    // Open dropdown 
    const trigger = document.getElementById('dropdown-trigger');
    const menu = document.getElementById('dropdown_menu');

    if (trigger && menu) {
        trigger.addEventListener('click', () => {
            menu.classList.toggle('d-block');
        });
    }
});